/* global jQuery, js_vars, elementorFrontend, Mmenu */
const theme_url = ('themeurl' in js_vars) ? js_vars.themeurl : 'https://www.kyha.com/wp-content/themes/kyha';

/*--------------------------------------------------------------------------------
General Ready
--------------------------------------------------------------------------------*/
( function( $ ) {
$(document).ready(function(){
	
	const siteWidth = 1320,
	mobileWidth = 768;

	/*--------------------------------------------------------------------------------
	Utility: Hide element on click outside
	--------------------------------------------------------------------------------*/
	
	function hideOnClickOutside( selector, type = 'standard' ) {
		const outsideClickListener = (event) => {
			const $target = $(event.target);
			if ( ! $target.closest(selector).length ) {
				$(selector).removeClass('open');
				if ( type == 'menu' ) {
					$('#site-header').removeClass('active');
				}
				removeClickListener();
			}
		}

		const removeClickListener = () => {
			document.removeEventListener('click', outsideClickListener)
		}
		
		document.addEventListener('click', outsideClickListener)
	}


	/*--------------------------------------------------------------------------------
	Utility: Scroll to internal links
	--------------------------------------------------------------------------------*/

	// $('a[href*="#"]')
	// 	.not('[href="#"]')
	// 	.not('[href="#0"]')
	// 	.click(function( event ) {
	// 		if( location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname ) {
	// 			let target = $(this.hash);
	// 			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
	// 			if( target.length ) {
	// 				event.preventDefault();
	// 				$( 'html, body' ).animate({
	// 					scrollTop: target.offset().top - 36
	// 				}, 1000, function() {
	// 					let $target = $(target);
	// 					$target.focus();
						
	// 					if( $target.is(":focus") ) {
	// 						return false;
	// 					} else {
	// 						$target.attr('tabindex','-1');
	// 						$target.focus();
	// 					}
	// 				});
	// 			}
	// 		}
	// 	});


	/*--------------------------------------------------------------------------------
	Utility: Copy URL
	--------------------------------------------------------------------------------*/

	$( document ).on( 'click', '.copy-url', function(e){
		e.preventDefault();

		let $this = $(this);
		let url = $this.attr('href');

		navigator.clipboard.writeText(url).then(function() {
			$this.text('Copied!');
		});
	});		


	/*--------------------------------------------------------------------------------
	Mobile Menu - General
	--------------------------------------------------------------------------------*/

	// $(document).on( 'click', '#site-header__mobile-button', function(e){
	// 	let $this = $(this);
	// 	$this.toggleClass('is-active');
	// });

	// if( ! $('body').hasClass('elementor-editor-active') ) {
	// 	window.stickyHeader = $('#site-header').stickybits({
	// 		useStickyClasses: true
	// 	});

	// 	if( $(window).width() > mobileWidth ) {
	// 		$('.site-main').css("margin-top", - $('#site-header').height());
	// 	}
	// }


	/*--------------------------------------------------------------------------------
	Header - Search
	--------------------------------------------------------------------------------*/

	$('.header__search .icon').click(function(e){
		e.preventDefault();

		// Handle outside clicks
		let $parent = $(this).parent();
		$parent.toggleClass('open');
		hideOnClickOutside($parent);

		if( $parent .hasClass('open') ) {
			$parent.find('[name="s"]').focus();
		}
	});


	/*--------------------------------------------------------------------------------
	Forms: General
	--------------------------------------------------------------------------------*/

	$('.search-reset').click(function(e){
		e.preventDefault();
		resetSearchForm();
	});

	function resetSearchForm() {
		let form = $('#live-search-form');

		form.find('.search-reset').removeClass('active');

		form[0].reset();

		form.find('.dropdown-content').each(function() {
			let $this = $(this);
			$this.find('label').css('display', 'block');

			let firstEntry = $(this).find('label').first();
			let firstLabel = firstEntry.children('input').data('label');

			$this.parents('.form-dropdown').removeClass('parent_selected').removeClass('child_selected').css('display', 'block').find('.dropdown-title').text(firstLabel);
		});
	}

	/*--------------------------------------------------------------------------------
	Forms: Dropdown
	--------------------------------------------------------------------------------*/

	$('.form-dropdown .dropdown-title').click(function(e){
		e.preventDefault();

		// Handle outside clicks
		let $parent = $(this).parent('.form-dropdown');
		$parent.toggleClass('open');
		hideOnClickOutside($parent);
	});

	$(document).on( 'change', '.dropdown-content', function(e) {
		// Hide dropdown
		$('.form-dropdown').removeClass('open');
		
		// Show reset button
		$('.search-reset').addClass('active');

		let target = $(e.target);
		let dropdown_label = target.data('label');

		let dropdown_form = target.parents('.form-dropdown');
		dropdown_form.find('.dropdown-title').text(dropdown_label);

		// Uncheck all other inputs in this dropdown, used for dropdown relationships multi-selection
		$(this).find('input[type="checkbox"]').not(target).each(function(){
			$(this).prop('checked', false);
		});

		// Reset form on Staff "view all"
		if( target.attr('id') == 'staff_category-all' ) {
			resetSearchForm();
		} else {
			// Handle dropdown content relationships
			if( dropdown_form.hasClass('relationship-parent') ) {
				// Fetch child of this dropdown
				let dropdown_child = dropdown_form.siblings('.relationship-child');
				let parent_id = target.val();

				// Check if child has already been selected
				if( ! dropdown_child.hasClass('child_selected') ) {
					console.log('child selected');
					// If parent is first, set taxonomy query to be exclusive
					$('#live-search-form').data('tax_query', 'AND');
					dropdown_child.addClass('parent_selected');
					
					// Clear any options chosen in the child dropdown
					dropdown_child.find('input[type="checkbox"]').each(function(){
						$(this).prop('checked', false);

						let childLabel = dropdown_child.find('label').first().children('input').data('label');
						dropdown_child.find('.dropdown-title').text(childLabel);
					});

					// Update available options in the child dropdown
					dropdown_child.find('label').not('[data-parentid="all"]').css('display', 'none').filter(function(val, element) {
						if( $(this).data('parentid') == parent_id ) {
							$(this).css('display', 'block');
						}
					});
				}
				
				if( dropdown_child.hasClass('parent_selected') ) {
					console.log('parent change 2');
				}
				
			} else if( dropdown_form.hasClass('relationship-child') ) {
				// Trigger when child is selected before parent
				if( ! dropdown_form.hasClass('parent_selected' ) ) {
					dropdown_form.siblings('.relationship-parent').css('display', 'none');
					// Combine the tax queries
					// $('#live-search-form').attr('data-tax_query', 'OR');
					// dropdown_form.addClass('child_selected');
				}
			}
		}
	});


	/*--------------------------------------------------------------------------------
	Forms: Tabs
	--------------------------------------------------------------------------------*/

	$('.live-search-container .search-tab .tab-label').click(function(e){
		e.preventDefault();
		$(this).toggleClass('open');
	});

	$('.live-search-container .form-tab .tab-title').click(function(e){
		e.preventDefault();
		$(this).toggleClass('open');
	});

	$('.live-search-container .search-reset').click(function(e){
		e.preventDefault();
		let $form = $(this).parents('form.live-search-form');
		$form[0].reset();
		$form.submit();
	});


	/*--------------------------------------------------------------------------------
	Navigation: Desktop
	--------------------------------------------------------------------------------*/

	$(document).on( 'click', '#menu-button--desktop', function(e) {
		e.preventDefault();
		let $header = $('#site-header');

		if( ! $header.hasClass('active') ) {
			hideOnClickOutside('#site-navigation', 'menu');
			$header.addClass('active');
			$('#site-navigation').addClass('open');
		}
	});


} );
} )( jQuery );


/*--------------------------------------------------------------------------------
Mobile Menu - Mmenu.js
--------------------------------------------------------------------------------*/
document.addEventListener(
	"DOMContentLoaded", () => {
		let navigationButtons = document.getElementById('navigation__buttons');
		
		let navigationButtonsPanel = {};
		if( navigationButtons ) {
			let navigationButtonsInner = navigationButtons.innerHTML;
			navigationButtonsPanel = {
				"position": "bottom",
				"content": [
					'<div class="mobile__footer">' + navigationButtonsInner + '</div>'
				]
			};
		}

		new Mmenu( "#mobile-navigation", {
			"theme": "light",
			"navbar": {
				"add": false
			},
			"navbars": [
				{
					"position": "top",
					"content": [
						"prev",
						"title",
						"close"
					]
				},
				{
					"position": "top",
					"content": [
						'<div class="mobile__search"><form class="search-input" action="/"><input type="text" placeholder="Search" name="s" /><input type="hidden" name="post_type" value="post" /></form></div>'
					]
				},
				navigationButtonsPanel
			],
			// hooks: {
			// 	"openPanel:before": ( panel ) => {
			// 		let nav_top = document.getElementById("mobile-menu");
			// 		if( panel.id == 'mm-1' ) {
			// 			nav_top.classList.add("mm-home");
			// 		} else {
			// 			nav_top.classList.remove("mm-home");
			// 		}
			// 	}
			// }
		}, {
			"offCanvas": {
				// "clone": "true",
				"page": {
					selector: "#site-container"
				},
				"position": "left"
			},
		});
	}
);